<template>
  <Dropdown
    :overlay="false"
    :trigger-attrs="{
      icon: 'dot',
      shape: 'circle',
      size: 'xsmall',
      color: 'transparentWhite',
      iconButton: true,
      disabled: !stationOk || loading,
    }"
    :menu-attrs="{ class: 'tw-min-w-0 tw-p-2 tw-flex tw-flex-col tw-gap-2' }"
  >
    <template #menu>
      <Button
        size="small"
        color="red"
        class="tw-whitespace-nowrap"
        :loading="startRecordingLoading"
        :disabled="loading"
        @click="startRecording"
      >
        {{ t('station_recording_buttons.start_all') }}
      </Button>

      <Button
        size="small"
        color="transparentRed"
        outlined
        class="tw-whitespace-nowrap"
        :loading="stopRecordingLoading"
        :disabled="loading"
        @click="stopRecording"
      >
        {{ t('station_recording_buttons.stop_all') }}
      </Button>
    </template>
  </Dropdown>
</template>

<script setup>
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';

import { Button, Dropdown } from '@slideslive/fuse-kit/vue';

import performNateApiRequest from '@/helpers/perform_nate_api_request';

const props = defineProps({
  station: { type: Object, required: true },
});

const { t } = useI18n();

const startRecordingLoading = ref(false);
const stopRecordingLoading = ref(false);

const loading = computed(() => startRecordingLoading.value || stopRecordingLoading.value);
const stationOk = computed(() => props.station?.status === 'ok');

async function startRecording() {
  if (!window.confirm(t('station_recording_buttons.confirm_start'))) return;

  startRecordingLoading.value = true;
  await performNateApiRequest({ station: props.station, endpoint: '/recorders/-/start_all' });
  startRecordingLoading.value = false;
}

async function stopRecording() {
  if (!window.confirm(t('station_recording_buttons.confirm_stop'))) return;

  stopRecordingLoading.value = true;
  await performNateApiRequest({ station: props.station, endpoint: '/recorders/-/stop_all' });
  stopRecordingLoading.value = false;
}
</script>
